/* eslint-disable @typescript-eslint/no-explicit-any */

import classNames from 'classnames';
import { DEFAULT_THEME } from 'lib/constants';
import { getThemeClass } from 'lib/utils/utilityFunction';
import { JSX } from 'react';

export type ComponentWrapperProps = {
  children?: React.ReactNode | React.ReactNode[];
  dataComponent?: string;
  className?: string;
  isSidenavPart?: boolean;
  disableThemeInsideSideNav?: boolean;
  disableThemeOutsideSideNav?: boolean;
  ariaLabel?: string;
  role?: string;
  params?: {
    Theme?: string;
  };
};

const ComponentWrapper = ({
  children,
  dataComponent,
  ariaLabel,
  role,
  className,
  ...props
}: ComponentWrapperProps): JSX.Element => {
  const theme = props?.params?.Theme;
  const themeClass = getThemeClass(theme || '');

  return (
    <section
      className={classNames(
        `component component-theme`,
        className ? className : '',
        !props?.isSidenavPart
          ? `${!props?.disableThemeOutsideSideNav ? themeClass : DEFAULT_THEME} py-[48px] lg:py-[80px]`
          : '',
        props?.isSidenavPart && props?.disableThemeInsideSideNav ? themeClass : '',
        'group-[]/modern:!py-0 group-[]/modern:!p-0'
      )}
      data-component={dataComponent}
      aria-label={ariaLabel}
      role={role}
    >
      {children}
    </section>
  );
};
export default ComponentWrapper;
